import React, {useEffect} from 'react';
import CardDeck from 'react-bootstrap/CardDeck';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import { formatDate, formatTime } from './utils/dateUtils';

function ServicesPage({loadingServiceData, loadedServiceData, serviceData, getServiceData}) {

    useEffect(() => {
        if(!serviceData.length && !loadingServiceData && !loadedServiceData) {
            getServiceData();
        }
    }, [])

    const getStartDateText = (service) => {
        const startDate = new Date(service.StartTime);
        return formatDate(startDate);
    }

    const getStartTime = (service) => {
        const startDate = new Date(service.StartTime);
        const startTime = new Date(startDate.getTime() + service.IntroLengthMins * 60000);
        return startTime;
    }

    const getStartTimeText = (service) => {  
        return formatTime(getStartTime(service));
    }

    const getEndTimeText = (service) => {
        const startTime = new Date(service.StartTime);
        const videoIDs = Object.keys(service.VideoDurations);
        const videoDurationList = videoIDs.map(videoID => service.VideoDurations[videoID].Duration);
        const serviceDurationSecs = videoDurationList.reduce((accumulator, currentValue) => {
            return accumulator + currentValue;
        });
        const endTime = new Date(startTime.getTime() + serviceDurationSecs * 1000);
        return formatTime(endTime);
    }

    const serviceList = serviceData.map((service) =>
        <Card key={service.ServiceID} style={{minWidth: '18rem', marginBottom: '30px'}}>
            <Card.Header>
                <Card.Title>{service.ServiceTitle}</Card.Title>
            </Card.Header>
            <Card.Body>      
                <Card.Text>
                    Location: {service.Location}    
                </Card.Text>          
                <Card.Text>
                    {getStartDateText(service)}  
                </Card.Text>
                <Card.Text>
                    Start Time: {getStartTimeText(service)}
                </Card.Text>
                <Card.Text>
                    End Time: {getEndTimeText(service)}
                </Card.Text>
                <Card.Text>
                    Watch window closed: {formatTime(service.EndTime)}
                    <br />
                    <small className="text-muted">Viewers who started the service late have until this time to finish watching</small>
                </Card.Text>
            </Card.Body>
            <Card.Footer>
                <Link to={`/Services/${service.ServiceID}`}>
                    Service Details
                </Link>
            </Card.Footer>
        </Card> 
    );

    return (
        loadingServiceData ?  
            <span>Loading...</span> 
            : 
            <div>
                <h5 style={{textAlign: 'left', marginLeft: '25px', marginBottom: '25px'}}>Upcoming Services:</h5>
                <CardDeck style={{margin: '10px'}}>{serviceList}</CardDeck>
            </div>
    );
}

export default ServicesPage;
